import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-hand-point-left" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrows-alt" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "d-flex sticky-top position-absolute d-flex justify-content-between px-5 py-4 top-0 end-0" }

import { onMounted, reactive } from "vue";
import InspectorButton from "./buttons/InspectorButton.vue";
import FileMenuExecButtons from "./dropdown/FileMenuExecButtons.vue";
import QrDialog from "../dialog/QrCodeDialog.vue";
import { DialogHandler } from "../dialog/DialogHandler";
import DialogContiainer from "../dialog/DialogsContainer.vue";
import { projectContext } from "../../blockly/ProjectContext";
import { useRoute, useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'ExecHeader',
  setup(__props) {

const router = useRouter();
const route = useRoute();

const openQr = () => {
  DialogHandler.showQRDialog();
};

const containerClass = reactive({ "px-5": true, "py-4": true });
const inspectorClass = reactive({ "btn-light": true });
const returnButtonClass = reactive({ "btn-light": true });

const onReturn = () => {
  const project_id = route.params.project_id;
  router.push({ name: "BlocklyPage", params: { project_id: project_id } });
};

const positionEditor = () => {
  const iframe = document.getElementById("executeFrame") as any;
  const blocks: NodeList = iframe.contentDocument.querySelectorAll("[data-block_id]");

  // toggle
  projectContext.enablePositionEditor.value = !projectContext.enablePositionEditor.value;
  projectContext.nodeList.value = blocks;
};
onMounted(() => {
  projectContext.enablePositionEditor.value = false;
});
const inspector = () => {
  const iframe = document.getElementById("executeFrame") as any;
  const scene = iframe.contentDocument.querySelector("a-scene");

  // const isInspector = () => {
  //   // inspectorに入っていたらSceneに付属する属性
  //   const inInspector = scene.hasAttribute('aframe-inspector-removed-embedded');
  //   return;
  // };

  scene.components.inspector.openInspector();

  inspectorClass["d-none"] = true;
  // returnButtonClass['d-none'] = true;
  containerClass["px-5"] = false;
  containerClass["py-4"] = false;
  containerClass["py-1"] = true;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("span", {
        class: _normalizeClass(["d-flex sticky-top position-absolute d-flex justify-content-between", containerClass])
      }, [
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(["btn mx-1", returnButtonClass]),
          onClick: onReturn
        }, _hoisted_3, 2),
        _createVNode(InspectorButton, {
          "additional-class": inspectorClass,
          onClick: inspector
        }, null, 8, ["additional-class"]),
        _createElementVNode("button", {
          class: "btn btn-light mx-1",
          onClick: positionEditor
        }, _hoisted_5)
      ], 2),
      _createElementVNode("span", _hoisted_6, [
        _createVNode(FileMenuExecButtons, { onOpenQr: openQr })
      ])
    ]),
    _createVNode(QrDialog),
    _createVNode(DialogContiainer)
  ], 64))
}
}

})